// extracted by mini-css-extract-plugin
module.exports = {"mailchimp":"Mailchimp_mailchimp__t_yvN","dropClass":"Mailchimp_dropClass__rzrFa"};